import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Project } from "../../data-models/project";
import { DataService } from "../../services/data-service";
import { useStoreState } from "../../store/data-store";

const ProjectPage = () => {

    const [ isLoading, setLoading] = useState(false);
    const [ projects, setProjects] = useState<Project[]>([])
    const navigate = useNavigate();

    const user = useStoreState(store => store.user);

    useEffect(() => {
        async function loadProjects() {
            setLoading(true);
            const dataService = new DataService();
            const tokens = await dataService.getAccessToken(user);
            const projects = await dataService.getProjects(user.id, tokens.accessToken);
            setProjects(projects);
            setLoading(false);
        }
        loadProjects();
    },[user])

    function addProject () {
        navigate("/projects/0");
    }

    return (
        <div className="page-section">
        <div className="section-title">Projects Page</div>
        { isLoading && <div>...loading</div> }
        <div className="data-section projects-section">
            <table>
                <thead>
                <tr className="table-header">
                    <th className="col-project-name">Project Name<FontAwesomeIcon icon="add" onClick={addProject} title="Add a new Project" /></th>
                    <th className="col-designer">Designer</th>
                </tr>
                </thead>
                <tbody>
            {
                projects.map((p,idx) => {
                    return (
                      <tr key={idx}>
                        <td className="col-project-name"><Link to={"/projects/"+p.id}>{p.name}</Link></td>
                        <td className="col-designer">{p.designer}</td>
                      </tr>
                    );
                })
            }
            </tbody>
            </table>
            
        </div>
    </div>

    )
}
export default ProjectPage;